import React, { Component } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { assignInitialUser } from '../actions/userActions';
import { fetchUserBehavior } from '../actions/userBehaviorActions';

import Intro from '../containers/Onboarding/Intro';
import Onboarding from '../containers/Onboarding';
import MicroTools from '../containers/Microtools';
import Calculators from '../containers/Calculators/index';
import Surveys from '../containers/Surveys/index';
import Unsubscribe from '../containers/Unsubscribe';
import { NoMatch404 } from '../components/NoMatch404';

import App from './App.js';
import LogIn from './LogIn.js';
import { logPage } from '../helpers/analytics';
import { wlPath } from '../helpers/whitelabel';

export class AppRouter extends Component {
  componentDidUpdate() {
    logPage();
  }

  componentWillUpdate(nextProps, nextState) {
    // Remove trailing slash if necessary
    const { history, location } = this.props;
    if (location.pathname.slice(-1) == '/') {
      history.replace(location.pathname.slice(0, -1));
    }
  }

  componentWillMount() {
    // HRBR_USER is pulled from layouts/react.  Poor mans server-side rendering
    this.props.dispatch(assignInitialUser(HRBR_USER));
  }

  componentDidMount() {
    this.props.dispatch(fetchUserBehavior());
  }

  render() {
    return (
      <App location={this.props.location}>
        {this.props.user_fetched && (
          <Switch>
            <Route exact path={wlPath('/')} component={Intro} />
            <Route path={wlPath('/start')} component={Onboarding} />
            <Route path={wlPath('/action-plan')} component={MicroTools} />
            <Route path={wlPath('/calculators')} component={Calculators} />
            <Route path={wlPath('/surveys')} component={Surveys} />
            <Route path={wlPath('/unsubscribe')} component={Unsubscribe} />
            <Route component={NoMatch404} />
          </Switch>
        )}
      </App>
    );
  }
}

function mapStateToProps(state) {
  return {
    user_fetched: state.user.fetched,
  };
}

export default connect(mapStateToProps)(withRouter(AppRouter));
